const MesureCloseStyle = {
  bg: "white",
};

export { MesureCloseStyle };
